// The ECMWorks lockup and tile, as inline SVG. Geometry, colors and the
// wordmark settings are the supplied files in brand/logo-pack/svg/ verbatim
// (ECM 700 / Works 400, tracked −2%). Inline so the wordmark renders in the
// page's self-hosted Bitter; an external SVG <img> cannot reach page fonts.
//
// Rules: horizontal lockup minimum 120px wide; below 24px use the tile alone;
// clear space = one beam height on every side.
//
// WebKit ignores letter-spacing on SVG text, so the wordmark rendered ~13 units
// wider in Safari and clipped. textLength pins its width in every engine; the
// viewBox carries 16 units of slack on the right (WebKit ignores textLength
// when the text has tspans, so the slack is what actually protects Safari).

interface LockupProps {
  /** 'dark' = on forest ground (cream tile, cream wordmark); 'light' = on cream ground. */
  ground: 'dark' | 'light';
  /** Rendered height in px (width follows at 316:72). Default 36 → 158px wide. */
  height?: number;
  className?: string;
}

const CREAM = '#EDE9DD';
const FOREST = '#1F3329';
const BRASS = '#B58B3A';

export const Lockup = ({ ground, height = 36, className }: LockupProps) => {
  const tile = ground === 'dark' ? CREAM : FOREST;
  const beam = ground === 'dark' ? FOREST : CREAM;
  const text = ground === 'dark' ? CREAM : FOREST;
  const width = Math.round((height * 316) / 72);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 316 72"
      role="img"
      aria-label="ECMWorks"
      className={className}
      focusable="false"
    >
      <g transform="translate(4,4)">
        <rect width="64" height="64" rx="6" fill={tile} />
        <rect x="12" y="12" width="40" height="10" fill={beam} />
        <rect x="12" y="27" width="28" height="10" fill={BRASS} />
        <rect x="12" y="42" width="40" height="10" fill={beam} />
      </g>
      <text x="84" y="52" fontFamily="Bitter, Georgia, serif" fontSize="44" letterSpacing="-0.88" textLength="215" lengthAdjust="spacing" fill={text}>
        <tspan fontWeight="700">ECM</tspan>
        <tspan fontWeight="400">Works</tspan>
      </text>
    </svg>
  );
};

interface TileProps {
  ground: 'dark' | 'light';
  size?: number;
  className?: string;
}

/** The beams tile alone — the only mark permitted below 24px, and the one that sits beside a menu icon. */
export const Tile = ({ ground, size = 32, className }: TileProps) => {
  const tile = ground === 'dark' ? CREAM : FOREST;
  const beam = ground === 'dark' ? FOREST : CREAM;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 64 64"
      role="img"
      aria-label="ECMWorks"
      className={className}
      focusable="false"
    >
      <rect width="64" height="64" rx="6" fill={tile} />
      <rect x="12" y="12" width="40" height="10" fill={beam} />
      <rect x="12" y="27" width="28" height="10" fill={BRASS} />
      <rect x="12" y="42" width="40" height="10" fill={beam} />
    </svg>
  );
};
